import { KOELCEL_OPTIES, AFLEVER_CEL_ID, COR_CEL_ID } from "../constants";

export function buildKoelcelOptions(extraKoelcellen) {
  return [
    ...KOELCEL_OPTIES,
    ...(extraKoelcellen?.aflevercel ? [AFLEVER_CEL_ID] : []),
    ...(extraKoelcellen?.cor ? [COR_CEL_ID] : []),
  ];
}

export function koelcelLabel(kc) {
  if (kc === AFLEVER_CEL_ID) return "Aflevercel";
  if (kc === COR_CEL_ID) return "Cor";
  return `Koelcel ${kc}`;
}
